import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import preventDefault from 'ember-event-helpers/helpers/prevent-default';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import and from 'rise-ui/helpers/and.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import fnx from 'rise-ui/helpers/fnx';
import isFalse from 'rise-ui/helpers/is-false';
import noUrl from 'rise-ui/helpers/no-url.js';
import noUrlTarget from 'rise-ui/helpers/no-url-target.js';
import not from 'rise-ui/helpers/not.js';
import or from 'rise-ui/helpers/or.js';

export default class CButtonButtonComponent extends Component {
  <template>
    {{#if (and @linkTo (not @disabled))~}}

      <LinksTo
        @route={{@linkTo}}
        role="button"
        @noOpenIcon="true"
        @open={{@isExplicitlyExternal}}
        @target={{or @target (if @isExplicitlyExternal "_blank")}}
        @rel={{or @rel (if @isExplicitlyExternal "noopener noreferrer")}}
        @preventDefault={{@preventDefault}}
        @defaultLink={{@defaultLink}}
        @disabled={{@disabled}}
        @onClick={{@onClick}}
        title={{@title}}
        class={{classMod config=@classModConfig}}
        {{on "click" (fnx (unless (isFalse @stopPropagation) (stopPropagation)))}}
        ...attributes
      >
        {{~yield~}}
      </LinksTo>

    {{~else if (and @externalUrl (not @disabled))~}}

      <a href={{noUrl @externalUrl}}
        role="button"
        target={{noUrlTarget @externalUrl "_blank"}}
        rel="noopener noreferrer"
        title={{@title}} class={{classMod config=@classModConfig}}
        {{on "click" (if @disabled (preventDefault) @onClick)}}
        {{on "click" (stopPropagation)}}
        ...attributes
      >
        {{~yield~}}
      </a>

    {{~else~}}

      <button type="button"
        disabled={{@disabled}}
        title={{@title}}
        class={{classMod config=@classModConfig}}
        {{on "click" @onClick}}
        {{on "click" (stopPropagation)}}
        ...attributes
      >
       {{~yield~}}
      </button>

    {{~/if}}
  </template>
}
